import { motion } from "framer-motion";
import { CHAPTERS } from "@/lib/site";

function Chapter({ ch, i }) {
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start py-12 md:py-16 border-t border-[var(--mpg-border)]"
      data-testid={`chapter-${ch.n}`}
    >
      <div className="md:col-span-5 relative">
        <motion.span
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-mono text-[22vw] md:text-[11vw] leading-none text-[rgba(244,240,230,0.06)] block select-none"
        >
          {ch.n}
        </motion.span>
      </div>
      <div className="md:col-span-7 md:pt-8">
        <motion.h3
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-3xl md:text-5xl tracking-tight mb-6"
        >
          {ch.title}
        </motion.h3>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="text-lg md:text-xl font-light leading-relaxed text-[var(--mpg-text-soft)] max-w-xl"
        >
          {ch.body}
        </motion.p>
      </div>
    </div>
  );
}

export default function Manifesto() {
  return (
    <section
      id="philosophy"
      className="py-24 md:py-32 lg:py-40 bg-[var(--mpg-surface)]"
      data-testid="manifesto"
    >
      <div className="max-w-[1800px] mx-auto px-8 md:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="mb-16 md:mb-24 max-w-3xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--mpg-gold)] mb-6">
            The Philosophy
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            How we <span className="italic font-light">think</span> about ownership.
          </h2>
        </motion.div>

        {CHAPTERS.map((ch, i) => (
          <Chapter key={ch.n} ch={ch} i={i} />
        ))}
      </div>
    </section>
  );
}
